import React from 'react';
import { LayoutJustify } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { arrayOf, bool, object, oneOf, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames, enumValues, isEnumValid } from '@philips-internal/oswald-ui-utils';
import { TooltipTrigger } from '../../tooltip/tooltip-constants.js';
import { Tooltip } from '../../tooltip/tooltip.js';
import { LegendItem } from '../legend-item/legend-item.js';
import { LegendsSize } from '../legends-constants.js';
import { useOptionalLegends } from '../legends-context.js';
import { LegendItemListAPI } from './legend-item-list-api.js';
import './legend-item-list.css';
function LegendItemList(props) {
    const legends = useOptionalLegends();
    const size = legends?.size ?? props.size;
    const className = classNames({
        'c-legend-item-list': true,
        'c-legend-item-list--vertical': Boolean(props.vertical),
        'u-scrollbar': true,
        [`c-legend-item-list--${size}`]: isEnumValid(LegendsSize, size),
        [`${props.className}`]: Boolean(props.className),
    });
    return (React.createElement("ul", { "aria-label": MessageService.translate('tws.legend-item-list.label'), className: className, style: { justifyContent: props.justifyContent } }, props.data.map((item) => {
        const label = item.label ?? item.value;
        return (React.createElement(Tooltip, { key: item.value, triggers: [props.hideLegendLabel ? TooltipTrigger.HOVER : TooltipTrigger.ELLIPSIS], value: label },
            React.createElement("li", null,
                React.createElement(LegendItem, { ...item, hideLabel: props.hideLegendLabel, size: size }))));
    })));
}
LegendItemList.defaultProps = {
    data: [],
    hideLegendLabel: true,
    justifyContent: LayoutJustify.START,
    size: LegendsSize.NORMAL,
};
LegendItemList.propTypes = {
    className: string,
    data: arrayOf(object).notEnumerable(),
    hideLegendLabel: bool,
    justifyContent: oneOf([LayoutJustify.START, LayoutJustify.END]).group('alignment'),
    size: oneOf(enumValues(LegendsSize)).group('style'),
    vertical: bool.group('alignment'),
};
const awesomeProps = {
    api: LegendItemListAPI,
    type: ComponentType.DATA_DISPLAY,
};
AwesomeComponent(awesomeProps)(LegendItemList);
export { LegendItemList, };
//# sourceMappingURL=legend-item-list.js.map